import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2, CheckCircle2, AlertCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState("pending"); // pending | paid | error

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { navigate("/berater", { replace: true }); return; }
    let tries = 0;
    let stop = false;
    const poll = async () => {
      if (stop) return;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          setState("paid");
          await refresh();
          setTimeout(() => navigate("/berater", { replace: true }), 1400);
          return;
        }
      } catch { /* retry */ }
      if (tries++ < 20) setTimeout(poll, 2000);
      else setState("error");
    };
    poll();
    return () => { stop = true; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0A1128] px-6 text-center" data-testid="payment-success">
      {state === "pending" && (<><Loader2 className="animate-spin text-[#C5A059]" size={40} /><p className="mt-4 text-white">Zahlung wird bestätigt …</p></>)}
      {state === "paid" && (<><CheckCircle2 className="text-[#276749]" size={48} /><p className="mt-4 text-lg font-semibold text-white">Freigeschaltet! Weiterleitung …</p></>)}
      {state === "error" && (<><AlertCircle className="text-[#C5A059]" size={44} /><p className="mt-4 text-white">Zahlung noch nicht bestätigt.</p><button onClick={() => navigate("/berater", { replace: true })} className="mt-5 rounded-full bg-[#C5A059] px-6 py-3 text-sm font-semibold text-[#0A1128]">Zum Dashboard</button></>)}
    </div>
  );
}
